<!-- 批量导入弹框 -->
<template>
  <el-dialog :visible.sync="dialogVisible" width="30%" center>
    <p class="p1">{{ type.title }}</p>
    <div class="main" v-if="type.title === '批量恢复'">
      <p>是否确认批量恢复如下员工账号</p>
      <p v-for="item in datas" :key="item.id">{{ item.loginAccount }} 生成时间： {{ item.createTime }}</p>
      <p>请注意，员工账户恢复为正常状态后，均为普通用户，若您</p>
      <p>需要设置该员工为可接单的定制师账户，请在恢复权限</p>
      <p>（普通用户）的编辑页面进行编辑。</p>
    </div>
    <div v-else class="main">
      <p>是否确认批量停用如下员工账号：</p>
      <p v-for="item in datas" :key="item.id">{{ item.loginAccount }} 生成时间： {{ item.createTime }} </p>
      <p>请注意，员工账户停用后即无法再正常使用（请注意财务风险）。</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="affirm">{{ type.text }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Api from "@/components/Api/index";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      type: "",//类型区分
      datas: {},//渲染的数据
    }
  },
  computed: {},
  watch: {},
  methods: {
    init(type, datas) {
      console.log(type, datas, '撒打算弟弟');
      this.type = type
      this.datas = datas
      this.dialogVisible = true
    },
    //确认
    affirm() {
      this.$confirm(`您${this.type.text}吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = JSON.parse(JSON.stringify(this.datas))
        data.forEach(item => {
          this.$set(item, 'status', this.type.title === '批量停用' ? 2 : 1)
        })
        new Api("user")
          .updateUserList(data)
          .then((res) => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: `${this.type.text}成功!`
              });
              let sw =  {
                    '2': {
                      title: '批量停用',
                      name: '正常状态',
                      keys: 1,
                      text: '确认批量停用上述员工账号',
                    },
                    '1': {
                      title: '批量恢复',
                      name: '停用状态',
                      keys: 2,
                      text: '确认批量恢复上述员工账号',
                    }
                  }
              this.$emit('updateStatue',sw[this.type.keys])
              this.dialogVisible = false
            } else {
              this.$message.error(res.statusText);
            }
          })
          .catch(() => {
            this.$message({
              type: "error",
              message: "系统异常!",
            });
          });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.p1 {
  font-size: 0.16rem;
  color: #000;
  font-weight: bold;
  margin-bottom: 0.24rem;
}

.main {
  p {
    font-size: 0.14rem;
    color: #000;
    margin-bottom: 0.05rem;
  }
}
</style>